import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Spinner, Container } from 'react-bootstrap';
import { getVerisoulSessionId } from '../../Utils/verisoulHelper';
import { SurveysAPI } from '../../API/SurveysAPI';

// Country BACKEND base URL — must point at the backend server (port 9000 in dev),
// NOT the frontend dev server. Separate from REACT_APP_BASE_URL_API which is also
// used by axios for encrypted API calls and may be proxied differently.
const countryBackendURL = process.env.REACT_APP_COUNTRY_BACKEND_URL || 'http://localhost:9000';

class SurveyEntry extends Component<any, any> {
  async componentDidMount() {
    const { match } = this.props;
    const { surveyId, userId } = match.params;

    if (surveyId && userId) {
      const isVerisoulEnabled = await SurveysAPI.checkVerisoulEnabled(surveyId, undefined, userId);
      
      let verisoulSessionId = null;
      if (isVerisoulEnabled) {
        // Survey entry is typically a cold page load when redirected from backend.
        // Give the Verisoul SDK script injected by index.tsx up to 10s to load.
        verisoulSessionId = await getVerisoulSessionId(10000);
      }

      const redirectUrl = verisoulSessionId
        ? `${countryBackendURL}/surveys/${surveyId}/${userId}?verisoul_session_id=${encodeURIComponent(verisoulSessionId)}`
        : `${countryBackendURL}/surveys/${surveyId}/${userId}?bounced=true`;

      window.location.href = redirectUrl;
    }
  }

  render() {
    return (
      <Container className="d-flex flex-column align-items-center justify-content-center" style={{ minHeight: '60vh' }}>
        <Spinner animation="border" variant="primary" />
        <p className="mt-3 text-muted">Connecting to survey...</p>
      </Container>
    );
  }
}

export default withRouter(SurveyEntry);
